import { takeLatest, put } from 'redux-saga/effects';
import { fetchAppSettings, appNotify, setAppSettings } from 'store/actions';
import { getWithToken } from 'api/network';

export function* getAppSettingsSaga() {
  yield takeLatest(fetchAppSettings, function* () {
    try {
      const res = yield getWithToken(`/api/appSetting`);
      const data = yield res.json();
      const update = {...data};
      try {
        const inputValidationRes = yield getWithToken(`/api/appSetting/valuationInputSettings`);
        const inputValidationData = yield inputValidationRes.json();
        if (inputValidationData.data) {
          update.inputValidation = inputValidationData.data;
        } else if (inputValidationData.error) {
          console.log(inputValidationData.error);
        }
      } catch (error) {
        console.log(error);
      }
      yield put(setAppSettings({
        isLoading: false,
        hasData: true,
        ...update
      }));
    } catch (error) {
      yield put(setAppSettings({
        isLoading: false,
        hasData: false
      }));
      
      yield put(appNotify(`Failed to fetch app settings: ${error.message}`, 'error'));
    }
  });
}